import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function UsersEmptyState() {
  return (
    <Box
      component={Paper}
      p={3}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      sx={{ borderRadius: 2 }}
    >
      <Typography color="text.secondary">No users found</Typography>
    </Box>
  );
}
